/* np-khub-ja.js — Klaviyo Customer Hub 日本語表示の補正（Newport / dermalogica.jp）
 * Klaviyoの翻訳画面で編集できない定型文言を、Hub描画後に差し替える。
 * Hub（.kl-hub-drawer）の中だけを触る。Klaviyo側のDOMが変わって要素が見つからなければ何もしない。
 */
(function () {
  if (window.__npKhubJa) return;
  window.__npKhubJa = true;

  var PREF = {
    Hokkaido: '北海道', Aomori: '青森県', Iwate: '岩手県', Miyagi: '宮城県', Akita: '秋田県', Yamagata: '山形県',
    Fukushima: '福島県', Ibaraki: '茨城県', Tochigi: '栃木県', Gunma: '群馬県', Saitama: '埼玉県', Chiba: '千葉県',
    Tokyo: '東京都', Kanagawa: '神奈川県', Niigata: '新潟県', Toyama: '富山県', Ishikawa: '石川県', Fukui: '福井県',
    Yamanashi: '山梨県', Nagano: '長野県', Gifu: '岐阜県', Shizuoka: '静岡県', Aichi: '愛知県', Mie: '三重県',
    Shiga: '滋賀県', Kyoto: '京都府', Osaka: '大阪府', Hyogo: '兵庫県', Hyōgo: '兵庫県', Nara: '奈良県',
    Wakayama: '和歌山県', Tottori: '鳥取県', Shimane: '島根県', Okayama: '岡山県', Hiroshima: '広島県',
    Yamaguchi: '山口県', Tokushima: '徳島県', Kagawa: '香川県', Ehime: '愛媛県', Kochi: '高知県', Kōchi: '高知県',
    Fukuoka: '福岡県', Saga: '佐賀県', Nagasaki: '長崎県', Kumamoto: '熊本県', Oita: '大分県', Ōita: '大分県',
    Miyazaki: '宮崎県', Kagoshima: '鹿児島県', Okinawa: '沖縄県'
  };
  var CJK = /[぀-ヿ㐀-鿿]/;

  function yen(n) { return '￥' + Math.round(n).toLocaleString('ja-JP'); }
  function num(s) { var m = String(s).replace(/[,，\s]/g, '').match(/-?\d+/); return m ? parseInt(m[0], 10) : NaN; }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }

  function fixLeaf(el) {
    var t = el.textContent, s = t.trim(), m;
    if ((m = s.match(/^#(\S+)を注文$/))) return setText(el, 'ご注文番号 #' + m[1]);
    if ((m = s.match(/^(\d{4})で終わる(.+)$/))) return setText(el, m[2] + '（末尾' + m[1] + '）');
    if ((m = s.match(/^(\d+)\s*アイテム$/))) return setText(el, m[1] + '点');
    if (s === 'プロファイル') return setText(el, '会員情報');
    if ((m = s.match(/^Japan\s+(〒.*)$/))) return setText(el, m[1]);
    if ((m = s.match(/^([A-Za-zōŌ]+)\s+(.+)$/)) && PREF[m[1]] && CJK.test(m[2])) return setText(el, PREF[m[1]] + m[2]);
  }

  function fixSummary(root) {
    var rows = root.querySelectorAll('[class*="summary-pricingRow"]');
    if (!rows.length) return;
    var map = {};
    rows.forEach(function (r) {
      var ps = r.querySelectorAll('p');
      if (ps.length < 2) return;
      var label = ps[0].textContent.replace(/[：:\s]/g, '');
      map[label] = { row: r, label: ps[0], value: ps[ps.length - 1] };
    });
    function pick() { for (var i = 0; i < arguments.length; i++) if (map[arguments[i]]) return map[arguments[i]]; }
    var total = pick('合計', 'お支払い合計（税込）'), ship = pick('送料・手数料', '送料'), disc = pick('割引'),
        sub = pick('アイテムの小計', '商品合計（税込）'), pre = pick('税抜き合計'), tax = pick('税金', 'うち消費税');
    if (!total || !sub) return;
    var T = num(total.value.textContent), S = ship ? num(ship.value.textContent) : 0,
        D = disc ? Math.abs(num(disc.value.textContent)) : 0;
    if (isNaN(T)) return;
    var goods = T - (isNaN(S) ? 0 : S) + (isNaN(D) ? 0 : D);
    setText(sub.label, '商品合計（税込）');
    setText(sub.value, yen(goods));
    if (ship) setText(ship.label, '送料');
    if (disc) setText(disc.label, '割引');
    setText(total.label, 'お支払い合計（税込）');
    if (pre) pre.row.style.display = 'none';
    if (tax) {
      setText(tax.label, 'うち消費税');
      tax.row.style.opacity = '0.75';
      if (total.row.nextSibling !== tax.row) total.row.parentNode.insertBefore(tax.row, total.row.nextSibling);
    }
  }

  function fixName(root) {
    root.querySelectorAll('h1, h2, h3, h4, p').forEach(function (p) {
      if (p.children.length) return;
      var next = p.nextElementSibling;
      if (!next || next.textContent.indexOf('@') < 0) return;
      var cur = p.textContent.trim();
      if (p.getAttribute('data-np-name') === cur) return;
      var parts = cur.split(/\s+/);
      if (parts.length === 2 && CJK.test(parts[0]) && CJK.test(parts[1])) {
        var swapped = parts[1] + ' ' + parts[0];
        p.textContent = swapped;
        p.setAttribute('data-np-name', swapped);
      }
    });
  }

  function fixAria(root) {
    root.querySelectorAll('[aria-label="プロファイル"]').forEach(function (e) { e.setAttribute('aria-label', '会員情報'); });
  }

  function hideZero(root) {
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('[class*="summary-pricingRow"]')) return;
      var card = a, guard = 0;
      while (card.parentElement && guard++ < 8) {
        var parent = card.parentElement;
        var links = parent.querySelectorAll('a[href*="/products/"]');
        var hrefs = {};
        links.forEach(function (l) { hrefs[l.getAttribute('href')] = 1; });
        if (Object.keys(hrefs).length > 1) break;
        card = parent;
      }
      if (card === a || card.getAttribute('data-np-zero')) return;
      var priceZero = [].some.call(card.querySelectorAll('*'), function (e) {
        return !e.children.length && /^[￥¥]\s?0$/.test(e.textContent.trim());
      });
      if (priceZero) { card.style.display = 'none'; card.setAttribute('data-np-zero', '1'); }
    });
  }

  function run() {
    var root = document.querySelector('.kl-hub-drawer');
    if (!root) return;
    root.querySelectorAll('p, span, h1, h2, h3, h4, a, button, div').forEach(function (el) {
      if (!el.children.length && el.textContent.trim()) fixLeaf(el);
    });
    fixSummary(root);
    fixName(root);
    fixAria(root);
    hideZero(root);
  }

  var timer = null;
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; run(); }, 60); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  schedule();
})();
